import React from 'react';
import { Button } from '../ui/button';
import { Flag } from 'lucide-react';
import { formatDate } from './adminUtils';

export function ReportsTab({ reports, handleResolveReport }) {
  if (reports.length === 0) {
    return (
      <div className="text-center py-12 bg-white rounded-2xl border border-slate-100">
        <Flag className="w-10 h-10 text-slate-200 mx-auto mb-2" />
        <p className="text-slate-500">Bekleyen rapor yok</p>
      </div>
    );
  }
  return (
    <div className="space-y-3">
      {reports.map(r => (
        <div key={r._id} data-testid={`admin-report-${r._id}`} className="bg-white rounded-xl border border-slate-200 p-4">
          <div className="flex items-start justify-between gap-4">
            <div>
              <div className="flex items-center gap-2 mb-1">
                <span className="text-xs bg-red-50 text-red-700 px-2 py-0.5 rounded-full border border-red-200">{r.content_type === 'topic' ? 'Konu' : 'Yorum'}</span>
                <span className="text-xs text-slate-400">#{r.content_id}</span>
              </div>
              <p className="text-slate-700">{r.reason}</p>
              <div className="text-xs text-slate-400 mt-1">Şikayet eden: {r.reporter_username} · {formatDate(r.created_at)}</div>
            </div>
            <Button size="sm" variant="outline" onClick={() => handleResolveReport(r._id)} data-testid={`resolve-report-${r._id}`}>
              Çözümlendi
            </Button>
          </div>
        </div>
      ))}
    </div>
  );
}
